export default {
  sidebar: {
    config: 'Configuración',
    jobScheduleConfig: 'Configuración de Programación de Trabajo',
    jobSchedule: 'Calendario de Trabajo',
    daily: 'Diariamente',
    schedule: 'Programar',
  },
};
